import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import About from '@/pages/home/components/About';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-black">
      <Helmet>
        <title>About HUB30 | Jbeil's Premier Gym – CrossFit, Calisthenics & Strength</title>
        <meta
          name="description"
          content="Learn about HUB30 — Jbeil's #1 gym with 200+ active members, 10+ expert coaches, and 5+ disciplines. Strength training, CrossFit, calisthenics, and physiotherapy under one roof."
        />
        <meta
          name="keywords"
          content="about HUB30, gym Jbeil story, best gym Lebanon, HUB30 team, fitness community Jbeil, gym Byblos"
        />
        <link rel="canonical" href="https://hub30gym.com/aboutUs" />
        <meta property="og:title" content="About HUB30 | Jbeil's Premier Gym, Lebanon" />
        <meta property="og:description" content="HUB30 — 200+ members, 10+ coaches, 5+ disciplines. Jbeil's premier gym for strength, CrossFit, calisthenics, and physiotherapy." />
        <meta property="og:url" content="https://hub30gym.com/aboutUs" />
      </Helmet>
      <Navbar />
      <div className="pt-20">
        <About />
      </div>
      <Footer />
    </div>
  );
}
